import { useSyncExternalStore } from "react";
import {
  getAdminSessionEmail,
  subscribeAdminSessionEmail,
} from "@/features/auth/session/adminSessionEmail";

export function useAdminSessionEmail(): string {
  return useSyncExternalStore(
    subscribeAdminSessionEmail,
    getAdminSessionEmail,
    () => "",
  );
}
